import Tour from 'reactour';
import { useContext } from 'react';
import AuthContext from '../../store/auth-context';
import {
	disableBodyScroll,
	enableBodyScroll
} from 'body-scroll-lock';
import useGuidedTour from '../../hooks/use-guided-tour';
import { qamBillingGridTourSteps } from '../../utils/qamTours';
import { piBillingGridTourSteps } from '../../utils/piTours';

const lsBillingGridTourKey = 'billing-grid-tour';

const BillingGridTour = ({ status }) => {
	const authCtx = useContext(AuthContext);

	const { active } = useGuidedTour(
		lsBillingGridTourKey,
		'/billing-grid/'
	);

	let deployTour = false;

	if (
		active &&
		status === 'TWO' &&
		authCtx.userData.role === 'PI'
	) {
		deployTour = true;
	}
	if (active && authCtx.userData.role === 'QA') {
		deployTour = true;
	}

	let billingGridTourSteps = [];

	if (authCtx.userData.role === 'QA') {
		billingGridTourSteps = [...qamBillingGridTourSteps];
	} else {
		billingGridTourSteps = [...piBillingGridTourSteps];
	}

	const handleTourClose = () => {
		localStorage.setItem(lsBillingGridTourKey, true);
		window.location.reload();
	};

	const disableScroll = (target) => {
		disableBodyScroll(target);
	};

	const enableScroll = (target) => {
		enableBodyScroll(target);
	};

	if (!active) {
		return;
	}

	return (
		<Tour
			steps={billingGridTourSteps}
			isOpen={deployTour}
			onRequestClose={handleTourClose}
			accentColor='#242a60'
			rounded={7}
			disableInteraction={true}
			onAfterOpen={disableScroll}
			onBeforeClose={enableScroll}
		/>
	);
};

export default BillingGridTour;
